import { useEffect, useState } from 'react';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import config from '../../config';
import { DailyRewardModal } from '../dailyReward/DailyRewardModal';
import { WALLET_UPDATED_EVENT } from '../../constants/events';

const BALANCE_CACHE_KEY = 'balance_summary';
// Топбар перемонтируется на каждом переходе между страницами -
// не спамим запросом баланса чаще, чем раз в 5 секунд
const REFRESH_TTL_MS = 5000;
let lastFetchAt = 0;

const readCachedSummary = () => {
  try {
    const raw = localStorage.getItem(BALANCE_CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.error('Error reading balance cache:', error);
    return null;
  }
};

// Баланс монет + множитель дня серии в топбаре.
// По клику (на монету) открывает экран ежедневной награды.
// Значение кэшируется, чтобы при перемонтировании топбара (каждый переход
// между страницами) баланс не мигал нулём и не перезагружался лишний раз.
export function BalanceWidget() {
  const axiosPrivate = useAxiosPrivate();
  const [summary, setSummary] = useState(readCachedSummary); // { streak, walletCoins }
  const [isRewardOpen, setIsRewardOpen] = useState(false);

  useEffect(() => {
    const fetchSummary = (force = false) => {
      if (!force && Date.now() - lastFetchAt < REFRESH_TTL_MS) return;
      lastFetchAt = Date.now();

      axiosPrivate
        .get(config.API.DAILY_REWARD.SUMMARY)
        .then((res) => {
          const data = res.data?.data;
          if (!data) return;
          setSummary(data);
          try {
            localStorage.setItem(BALANCE_CACHE_KEY, JSON.stringify(data));
          } catch (error) {
            console.error('Error saving balance cache:', error);
          }
        })
        .catch((error) => console.error('Ошибка загрузки баланса:', error));
    };

    fetchSummary();

    // смена кошелька / возврат в приложение - всегда обновляем принудительно
    const onForceRefresh = () => fetchSummary(true);

    window.addEventListener(WALLET_UPDATED_EVENT, onForceRefresh);
    window.addEventListener('focus', onForceRefresh);

    return () => {
      window.removeEventListener(WALLET_UPDATED_EVENT, onForceRefresh);
      window.removeEventListener('focus', onForceRefresh);
    };
  }, []);

  // Баланс: целая часть крупно, копейки мельче (14,30)
  const [intPart, fracPart] = (summary ? Number(summary.walletCoins).toFixed(2) : '0,00').split('.');
  const streakMultiplier = summary?.streak || 1;

  return (
    <>
      <button
        type="button"
        aria-label="Ежедневная награда и баланс"
        onClick={() => setIsRewardOpen(true)}
        className="text-left cursor-pointer"
      >
        <p className="text-[12px] font-bold text-white/80">Баланс:</p>
        <div className="flex items-center gap-1.5">
          <img src="/icons/coin.svg" alt="монеты" className="size-[20px]" />
          <p className="text-[22px] text-white leading-3 font-raleway">
            {intPart},<span className="text-[16px] text-white/80">{fracPart}</span>
          </p>
          <span className="bg-[#A1F69E] text-[#010D0D] p-1 rounded-[4px] leading-3 font-bold h-full text-[12px]">
            x{streakMultiplier}
          </span>
        </div>
      </button>

      <DailyRewardModal isOpen={isRewardOpen} onClose={() => setIsRewardOpen(false)} />
    </>
  );
}
